module.exports = __webpack_public_path__ + "images/tipper-d77e17825146f9fb6066b87ea597d770.png";